export const LIVE_ODDS_RENDER_BUDGET = Object.freeze({
  boardEventsPerPage: 8,
  compactEventsPerPage: 24,
  exactOfferGroupsPerPage: 20,
  matrixMarketGroupsPerPage: 20,
})

export function pageSizeForOddsView(view) {
  if (view === 'board') return LIVE_ODDS_RENDER_BUDGET.boardEventsPerPage
  if (view === 'matrix') return LIVE_ODDS_RENDER_BUDGET.matrixMarketGroupsPerPage
  return view === 'exact'
    ? LIVE_ODDS_RENDER_BUDGET.exactOfferGroupsPerPage
    : LIVE_ODDS_RENDER_BUDGET.compactEventsPerPage
}

export function pageOddsItems(items, view, page) {
  const source = Array.isArray(items) ? items : []
  const pageSize = pageSizeForOddsView(view)
  const pageCount = Math.max(1, Math.ceil(source.length / pageSize))
  const safePage = Math.min(Math.max(0, Number(page) || 0), pageCount - 1)
  return {
    items: source.slice(safePage * pageSize, (safePage + 1) * pageSize),
    page: safePage,
    pageCount,
    pageSize,
  }
}
